export const MY_ACCOUNT = 'myAccount';
export const ADVICE = 'advice';
export const SEARCH = 'search';
export const SHOP = 'shop';
export const NUMBER_OF_RECOMMENDED_ITEMS = 10;
